import type {
  IncidentFormId,
  IncidentWorkItemId,
  IncidentWorkItemIdUnbranded,
  OrganisationId,
  UserDirectoryInstanceIdUnbranded,
  UserIdUnbranded,
} from "@thalamos/vision-common";

// TODO: Why are all of these unbranded? They are all being called by code under our control which we could validate.
export const createRoute = {
  help: () => "/help",
  home: () => "/",
  incidentActive: () => "/incident/active",
  incidentArchive: () => "/incident/archive",
  incidentCreate: () => "/incident/create",
  incidentPdfPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/pdf`,
  incidentProgressPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/progress`,
  incidentTriagePage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/triage`,
  incidentSectionComplete: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/section-complete`,
  incidentPersonDetailsPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/person-details`,
  incidentDetentionDetailsPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/detention-details`,
  incidentInformationForHealthcarePage: (
    incidentId: IncidentWorkItemIdUnbranded,
  ) => `/incident/${incidentId}/information-for-healthcare`,
  incidentMcaPersonDetailsPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/mca-person-details`,
  incidentMcaIncidentDetailsPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/mca-incident-details`,
  incidentMcaCapacityAssessmentPage: (
    incidentId: IncidentWorkItemIdUnbranded,
  ) => `/incident/${incidentId}/mca-capacity-assessment`,
  incidentMcaAccompanimentPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/mca-accompaniment`,
  incidentReviewPlacesOfSafetyPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/place-of-safety`,
  incidentRecordRetrospectivePlaceOfSafetyPage: (
    incidentId: IncidentWorkItemIdUnbranded,
  ) => `/incident/${incidentId}/place-of-safety/create-retrospective`,
  incidentRecordRetrospectivePlaceOfSafetyEditPage: (
    incidentId: IncidentWorkItemIdUnbranded,
    placeOfSafetyFormId: string,
  ) => `/incident/${incidentId}/place-of-safety/${placeOfSafetyFormId}/edit`,
  incidentRecordPlaceOfSafetyPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/place-of-safety/create`,
  incidentRecordPlaceOfSafetyArrivalPage: (
    incidentId: IncidentWorkItemId,
    placeOfSafetyFormId: IncidentFormId,
  ) => `/incident/${incidentId}/place-of-safety/${placeOfSafetyFormId}/arrival`,
  incidentRecordPlaceOfSafetyLeavePage: (
    incidentId: IncidentWorkItemId,
    placeOfSafetyFormId: IncidentFormId,
  ) => `/incident/${incidentId}/place-of-safety/${placeOfSafetyFormId}/leave`,
  incidentPreEndIncidentPage: (incidentId: IncidentWorkItemId) =>
    `/incident/${incidentId}/pre-end-incident`,
  incidentFinishFormPage: (incidentId: IncidentWorkItemId) =>
    `/incident/${incidentId}/finish-form`,
  incidentSharePage: (incidentId: IncidentWorkItemId) =>
    `/incident/${incidentId}/share`,
  incidentSummaryPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/summary`,
  incidentAdminEditReportingFieldsPage: (
    incidentId: IncidentWorkItemIdUnbranded,
  ) => `/incident/${incidentId}/admin/edit-reporting-fields`,
  incidentOfficerRequestPolicePresencePage: (
    incidentId: IncidentWorkItemIdUnbranded,
  ) => `/incident/${incidentId}/record-police-presence-request/create`,
  incidentPolicePresenceLogPage: (incidentId: IncidentWorkItemIdUnbranded) =>
    `/incident/${incidentId}/record-police-presence-request`,
  incidentPolicePresenceWhatWillYouDoPage: (
    incidentId: IncidentWorkItemIdUnbranded,
  ) =>
    `/incident/${incidentId}/record-police-presence-request/what-will-you-do`,
  notifications: () => "/notifications",
  login: () => "/login",
  userProfile: (id: UserIdUnbranded) => `/profile/${id}`,
  testErrorPage: () => "/test-error-page",
  adminOrganisationManagement: (organisationId: OrganisationId) =>
    `/admin/organisation/${organisationId}`,
  adminOrganisationConfigManagement: (organisationId: OrganisationId) =>
    `/admin/organisation/${organisationId}/config`,
  adminUserDirectoryInstanceManagement: (
    userDirectoryInstanceId: UserDirectoryInstanceIdUnbranded,
  ) => `/admin/user-directory-instance/${userDirectoryInstanceId}`,
  contextSelector: () => "/context-selector",
};
